import { OfflineDatabase } from './OfflineDatabase';
import axios from 'axios';

class SyncService {
    constructor() {
        this.isOnline = navigator.onLine;

        window.addEventListener('online', () => {
            this.isOnline = true;
            this.processQueue();
            console.log('App is online. Processing queue...');
        });

        window.addEventListener('offline', () => {
            this.isOnline = false;
            console.log('App is offline.');
        });
    }

    async processQueue() {
        if (!this.isOnline) return;

        const queue = await OfflineDatabase.getQueue();

        for (const item of queue) {
            try {
                // Replay the request
                // Assuming item has { method, url, data, headers }
                await axios({
                    method: item.method,
                    url: item.url,
                    data: item.data,
                    headers: item.headers
                });

                // Remove from queue on success
                await OfflineDatabase.removeFromQueue(item.id);
            } catch (error) {
                console.error('Failed to sync item', item, error);
                // Optionally verify if it's a server error vs network error to decide if retry later
            }
        }
    }

    // Helper to generic request
    async request(config) {
        if (this.isOnline) {
            try {
                return await axios(config);
            } catch (error) {
                // specific check for network error could be done here
                // if network error, fallback to queue
                if (!error.response) { // Network error typically
                    console.log('Network error, queuing request');
                    await OfflineDatabase.addToQueue(config);
                    return Promise.resolve({ data: { offline: true, message: 'Request queued' } });
                }
                throw error;
            }
        } else {
            console.log('Offline, queuing request');
            await OfflineDatabase.addToQueue(config);
            return Promise.resolve({ data: { offline: true, message: 'Request queued' } });
        }
    }
}

export default new SyncService();
